module.exports = __webpack_public_path__ + "static/img/5.be34d61.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/sp/5.png
// module id = fj2Z
// module chunks = 0